// extracted by mini-css-extract-plugin
export default {"transitWalletBlockPadding":"transitWallet_transitWalletBlockPadding__XutpA"};